import { createSlice } from "@reduxjs/toolkit";
import type { TemplateModel } from "../../../models/template";

const initialState = {
  loading: false,
  data: [] as TemplateModel[],
  error: null,
};

const dataSlice = createSlice({
  name: "list-models-for-theme",
  initialState: initialState,
  reducers: {
    initListModelsForTheme: () => {
      return { ...initialState };
    },
    startListModelsForTheme: (state) => {
      state.loading = true;
    },
    successListModelsForTheme: (state, action) => {
      state.loading = false;
      state.data = action.payload;
    },
    errorListModelsForTheme: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  initListModelsForTheme,
  startListModelsForTheme,
  successListModelsForTheme,
  errorListModelsForTheme,
} = dataSlice.actions;

export default dataSlice.reducer;
